module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_minicar_9d29b0dca2996f0a849ef40b33a89674.png";